<template>
  <section>
    <aside class="main-sidebar position-fixed bg-white border-right">
      <!-- Brand Logo -->
      <div class="sidebar-logo py-2">
        <router-link to="/dashboard">
          <img
            src="../../public/img/hotel-deliriver.png"
            alt="logo"
            class="brand-image img-circle"
            style="opacity: 0.8"
          />
        </router-link>
      </div>

      <!-- Sidebar -->
      <div class="sidebar pb-5">
        <!-- Sidebar Menu -->
        <nav class="text-left">
          <ul
            class="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <router-link
              to="/dashboard"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-chart-pie"></i>
              </div>
              <div class="">
                <p>Dashboard</p>
              </div>
            </router-link>
            <!-- <li class="nav-item p-0">
            <a href="" class="nav-link">
              Dashboard
            </a>
            <div class="nav nav-treeview">
              
                <a href="./index.html" class="nav-link active">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Dashboard v1</p>
                </a>
              </li>
            </div>
          </li> -->

            <router-link
              v-if="
                [
                  'superadmin',
                  'backoffice',
                  'receptionist',
                  'supervisor',
                ].includes(user?.role)
              "
              to="/guest"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-address-book"></i>
              </div>
              <div class="">
                <p>Guest</p>
              </div>
            </router-link>
            <router-link
              v-if="
                [
                  'superadmin',
                  'backoffice',
                  'receptionist',
                  'supervisor',
                ].includes(user?.role)
              "
              to="/room"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-door-open"></i>
              </div>
              <div class="">
                <p>Room</p>
              </div>
            </router-link>
            <router-link
              v-if="
                [
                  'superadmin',
                  'backoffice',
                  'receptionist',
                  'supervisor',
                ].includes(user?.role)
              "
              to="/reservation"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-clipboard-list"></i>
              </div>
              <div class="">
                <p>Reservation</p>
              </div>
            </router-link>
            <router-link
              v-if="
                [
                  'superadmin',
                  'backoffice',
                  'receptionist',
                  'supervisor',
                ].includes(user?.role)
              "
              to="/reservation"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-clipboard-list"></i>
              </div>
              <div class="">
                <p>Reservation</p>
              </div>
            </router-link>
            <router-link
              v-if="
                [
                  'superadmin',
                  'backoffice',
                  'receptionist',
                  'supervisor',
                ].includes(user?.role)
              "
              to="/checkin"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-calendar-plus"></i>
              </div>
              <div class="">
                <p>Check In</p>
              </div>
            </router-link>
            <router-link
              v-if="
                [
                  'superadmin',
                  'backoffice',
                  'receptionist',
                  'supervisor',
                ].includes(user?.role)
              "
              to="/in-house"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-house-user"></i>
              </div>
              <div class="">
                <p>In House</p>
              </div>
            </router-link>
            <router-link
              v-if="
                [
                  'superadmin',
                  'backoffice',
                  'receptionist',
                  'supervisor',
                ].includes(user?.role)
              "
              to="/checkout"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-calendar-minus"></i>
              </div>
              <div class="">
                <p>Check Out</p>
              </div>
            </router-link>

            <div
              class=""
              v-if="
                [
                  'superadmin',
                  'supervisor',
                  'receptionist',
                  'housekeeping',
                ].includes(user?.role)
              "
            >
              <a
                href=""
                class="nav-link d-flex justify-content-between align-items-center w-full mb-0"
                data-bs-toggle="collapse"
                :data-bs-target="'#housekeeping-sub'"
                aria-expanded="false"
                aria-controls="housekeeping-sub"
              >
                <div style="">
                  <i class="nav-icon fas fa-broom mr-2"></i>
                  <p>Housekeeping</p>
                </div>
                <i class="nav-icon fas fa-angle-down"></i>
              </a>
              <div
                id="housekeeping-sub"
                class="collapse ms-5 me-4"
                :class="{ show: isActive }"
              >
                <router-link
                  to="/schedule"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/schedule',
                    'text-muted py-2': $route.path !== '/schedule',
                  }"
                >
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p
                    :class="{
                      'mb-0': $route.path === '/schedule',
                      '': $route.path !== '/schedule',
                    }"
                  >
                    Schedule
                  </p>
                </router-link>
                <router-link
                  to="/cleaning"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/cleaning',
                    'text-muted': $route.path !== '/cleaning',
                  }"
                >
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p
                    :class="{
                      'mb-0': $route.path === '/cleaning',
                      '': $route.path !== '/schedule',
                    }"
                  >
                    Cleaning
                  </p>
                </router-link>
              </div>
            </div>
            <router-link
              v-if="
                [
                  'superadmin',
                  'supervisor',
                  'receptionist',
                  'maintenance',
                ].includes(user?.role)
              "
              to="/maintenance"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-wrench"></i>
              </div>
              <div class="">
                <p>Maintenance</p>
              </div>
            </router-link>
            <!-- <router-link to="/inventory" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-boxes"></i>
              </div>
              <div class="">
                <p>
                 Inventory
                </p>
              </div>
          </router-link> -->
            <div class="" v-if="user?.role === 'superadmin'">
              <a
                class="nav-link d-flex justify-content-between align-items-center w-full mb-0"
                data-bs-toggle="collapse"
                :data-bs-target="'#inventory-sub'"
                aria-expanded="false"
                aria-controls="inventory-sub"
              >
                <div style="">
                  <i class="nav-icon fas fa-boxes mr-2"></i>
                  <p>Inventory</p>
                </div>
                <i class="nav-icon fas fa-angle-down"></i>
              </a>
              <div
                id="inventory-sub"
                class="collapse ms-5 me-4"
                :class="{ show: isActive }"
              >
                <router-link
                  to="/inventory"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/inventory',
                    'text-muted py-2': $route.path !== '/inventory',
                  }"
                >
                  <p
                    :class="{
                      'mb-0': $route.path === '/inventory',
                      '': $route.path !== '/inventory',
                    }"
                  >
                    Overall
                  </p>
                </router-link>
                <router-link
                  to="/inventorywarehouse"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/inventorywarehouse',
                    'text-muted py-2': $route.path !== '/inventorywarehouse',
                  }"
                >
                  <p
                    :class="{
                      'mb-0': $route.path === '/inventorywarehouse',
                      '': $route.path !== '/inventorywarehouse',
                    }"
                  >
                    Warehouse
                  </p>
                </router-link>
                <router-link
                  to="/inventoryroom"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/inventoryroom',
                    'text-muted py-2': $route.path !== '/inventoryroom',
                  }"
                >
                  <p
                    :class="{
                      'mb-0': $route.path === '/inventoryroom',
                      '': $route.path !== '/inventoryroom',
                    }"
                  >
                    Room
                  </p>
                </router-link>
                <router-link
                  to="/inventoryspoil"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/inventoryspoil',
                    'text-muted py-2': $route.path !== '/inventoryspoil',
                  }"
                >
                  <p
                    :class="{
                      'mb-0': $route.path === '/inventoryspoil',
                      '': $route.path !== '/inventoryspoil',
                    }"
                  >
                    Defact
                  </p>
                </router-link>
              </div>
            </div>
            <div
              class=""
              v-if="user?.role === 'superadmin' || user?.role === 'backoffice'"
            >
              <a
                class="nav-link d-flex justify-content-between align-items-center w-full mb-0"
                data-bs-toggle="collapse"
                :data-bs-target="'#report-sub'"
                aria-expanded="false"
                aria-controls="report-sub"
              >
                <div style="">
                  <i class="nav-icon fas fa-copy mr-2"></i>
                  <p>Report</p>
                </div>
                <i class="nav-icon fas fa-angle-down"></i>
              </a>
              <div
                id="report-sub"
                class="collapse pl-5 me-4"
                :class="{ show: isActive }"
              >
                <router-link
                  to="/reservation-report"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/reservation-report',
                    'text-muted py-2': $route.path !== '/reservation-report',
                  }"
                >
                  <p
                    :class="{
                      'mb-0': $route.path === '/reservation-report',
                      '': $route.path !== '/reservation-report',
                    }"
                  >
                    Reservation Report
                  </p>
                </router-link>
                <router-link
                  to="/imigration-report"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/imigration-report',
                    'text-muted py-2': $route.path !== '/imigration-report',
                  }"
                >
                  <p
                    :class="{
                      'mb-0': $route.path === '/imigration-report',
                      '': $route.path !== '/imigration-report',
                    }"
                  >
                    Imigration Report
                  </p>
                </router-link>
                <router-link to="/" class="text-muted">
                  <p>Guests Report</p>
                </router-link>
                <router-link to="/" class="text-muted">
                  <p>Transaction Report</p>
                </router-link>
                <router-link to="/" class="text-muted">
                  <p>Extracharge Report</p>
                </router-link>
                <router-link to="/" class="text-muted">
                  <p>Maintenance Report</p>
                </router-link>
                <router-link to="/" class="text-muted">
                  <p>Inventory Report</p>
                </router-link>
              </div>
            </div>
            <router-link
              v-if="user?.role === 'superadmin' || user?.role === 'backoffice'"
              to="/staff"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-users"></i>
              </div>
              <div class="">
                <p>Staff</p>
              </div>
            </router-link>
            <router-link
              v-if="user?.role === 'superadmin' || user?.role === 'backoffice'"
              to="/vendor"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-store-alt"></i>
              </div>
              <div class="">
                <p>Vendor</p>
              </div>
            </router-link>
            <router-link
              v-if="user?.role === 'superadmin'"
              to="/admin"
              class="nav-link d-flex"
              active-class="bg-primary"
              exact-active-class="bg-primary"
            >
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-user-cog"></i>
              </div>
              <div class="">
                <p>Admin</p>
              </div>
            </router-link>

            <!-- <li class="nav-header">Master Data</li> -->
            <div
              class=""
              v-if="user?.role === 'superadmin' || user?.role === 'backoffice'"
            >
              <a
                href=""
                class="nav-link d-flex justify-content-between align-items-center w-full mb-0"
                data-bs-toggle="collapse"
                :data-bs-target="'#master-data-sub'"
                aria-expanded="false"
                aria-controls="master-data-sub"
              >
                <div style="">
                  <i class="nav-icon fas fa-database mr-2"></i>
                  <p>Master Data</p>
                </div>
                <i class="nav-icon fas fa-angle-down"></i>
              </a>
              <div
                id="master-data-sub"
                class="collapse ms-5 me-4"
                :class="{ show: isActive }"
              >
                <router-link
                  to="/room-category"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/room-category',
                    'text-muted py-2': $route.path !== '/room-category',
                  }"
                >
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p
                    :class="{
                      'mb-0': $route.path === '/room-category',
                      '': $route.path !== '/room-category',
                    }"
                  >
                    Room Category
                  </p>
                </router-link>

                <router-link
                  to="/staff-position"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/staff-position',
                    'text-muted py-2': $route.path !== '/staff-position',
                  }"
                >
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p
                    :class="{
                      'mb-0': $route.path === '/staff-position',
                      '': $route.path !== '/staff-position',
                    }"
                  >
                    Staff Position
                  </p>
                </router-link>
                <router-link
                  to="/maintenance-issue"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/maintenance-issue',
                    'text-muted py-2': $route.path !== '/maintenance-issue',
                  }"
                >
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p
                    :class="{
                      'mb-0': $route.path === '/maintenance-issue',
                      '': $route.path !== '/maintenance-issue',
                    }"
                  >
                    Maintenance Issue
                  </p>
                </router-link>
                <router-link
                  to="/payment-method"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/payment-method',
                    'text-muted py-2': $route.path !== '/payment-method',
                  }"
                >
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p
                    :class="{
                      'mb-0': $route.path === '/payment-method',
                      '': $route.path !== '/payment-method',
                    }"
                  >
                    Payment Method
                  </p>
                </router-link>
                <router-link
                  to="/extracharge-category"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/extracharge-category',
                    'text-muted py-2': $route.path !== '/extracharge-category',
                  }"
                >
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p
                    :class="{
                      'mb-0': $route.path === '/extracharge-category',
                      '': $route.path !== '/extracharge-category',
                    }"
                  >
                    Extra Charge Category
                  </p>
                </router-link>
                <router-link
                  to="/extracharge"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/extracharge',
                    'text-muted py-2': $route.path !== '/extracharge',
                  }"
                >
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p
                    :class="{
                      'mb-0': $route.path === '/extracharge',
                      '': $route.path !== '/extracharge',
                    }"
                  >
                    ExtraCharge Item
                  </p>
                </router-link>
                <router-link
                  to="/source"
                  :class="{
                    'd-flex align-items-center bg-primary rounded-lg p-2 my-2':
                      $route.path === '/source',
                    'text-muted py-2': $route.path !== '/source',
                  }"
                >
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p
                    :class="{
                      'mb-0': $route.path === '/source',
                      '': $route.path !== '/source',
                    }"
                  >
                    Source
                  </p>
                </router-link>
              </div>
            </div>

            <!-- //testing tampil nama user dan role
            <div class="nav-header">{{
              user?.username
            }}({{ user?.role }})</div>
            <span class="dropdown-item">{{
              user?.employee?.fullname ?? user?.username
            }}({{ user?.role }})</span> -->
          </ul>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
    </aside>
  </section>
</template>

<script>
import { computed, onMounted, ref } from "vue";

export default {
  setup() {
    const isActive = computed(() => {
      return (
        window.location.pathname === "/schedule" ||
        window.location.pathname === "/cleaning"
      );
    });

    const user = ref(null);

    onMounted(() => {
      const localUser = localStorage.getItem("user");
      user.value = localUser ? JSON.parse(localUser) : null;

      // console.log("data user login", user.value);
      // console.log("data user role", user.value.role);
    });

    return {
      isActive,
      user,
    };
  },
};
</script>

<style></style>
